module.exports = __webpack_public_path__ + "img/Close.7352ddb6.svg";